import RailTicketRestrictionsModal from './rail-ticket-restrictions-modal-component';
import RailTicketRestrictionsModalService from './rail-ticket-restrictions-modal-service';

const MODULE_NAME = 'app.rail.ticket-restrictions-modal';
const module = angular.module(MODULE_NAME, [])
    .directive('ktRailTicketRestrictionsModal', RailTicketRestrictionsModal)
    .service('railTicketRestrictionsModalService', RailTicketRestrictionsModalService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/rail-ticket-restrictions-modal/rail-ticket-restrictions-modal-module.js